import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { DisplayDetailsModalComponent } from '../../../core/modals/display-details/display-details.component';
import { LogCategory, LoggerService, LogPage, LogType } from '../../../core/services/logger.service';
import { FacilitiesIssueService } from '../../../services/facilities.issue.services';
 
@Component({
    selector: 'app-facilities-issue',
    templateUrl: './issue.component.html',
    styleUrls: ['./issue.component.scss'],
    standalone: false
})
export class FacilitiesIssueComponent implements OnInit, OnDestroy  {
    private _formSubscription: Subscription;
    private _resourceIssue$: Observable<any>;
    resources: any[];
    issues: any[];
    emergencyWeekendInfo = '';
    issuesByType: any[];
    objectKeys = Object.keys;
    objectEntries = Object.entries;
    postError = false;
    submittingToServer = false;
    postErrorMessage = '';
    selectedEntry = '';
    currentLocation = '';

    IssueForm: any = {
        resourceId: '', 
        issueId: '',
        issueLocation: '',
        describeIssue: ''
    }

    constructor(
        public issueService: FacilitiesIssueService,
        private logger: LoggerService,
        private router: Router,
        private modalService: NgbModal,
    ) {
        this.log("constructor", null, LogCategory.Constructor);   
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
        if (!Object.entries) {
            Object.entries = function (obj) {
                var ownProps = Object.keys(obj),
                    i = ownProps.length,
                    resArray = new Array(i); // preallocate the Array
                while (i--)
                    resArray[i] = [ownProps[i], obj[ownProps[i]]];

                return resArray;
            }
        }

        this.loadResourcesIssues();
        this.issueService.initializeFormValidationProperities(this.IssueForm);
        this.validate();
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", null, LogCategory.Destroy);

        if (!!this._formSubscription)
            this._formSubscription.unsubscribe();

    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Page, LogPage.Facilities, category);
    }

    onSubmit(form: NgForm) {
        this.log("onSubmit", "Submitting form to controller.");
        if (Object.keys(this.IssueForm.errors).length == 0) {
            this.submittingToServer = true;
            this._formSubscription = this.issueService.postReportIssue(this.IssueForm).subscribe((data) => { this.submittingToServer = false;this.notifySubmitter(data, form)}); 
        } else {
            this.postError = true;
            this.postErrorMessage = "Please fix errors.";
        }
    }

    public notifySubmitter(data: any, form: NgForm): void {
        this.log("notifySubmitter", "Modal Thank you and error form.");
        const modalRef = this.modalService.open(DisplayDetailsModalComponent);
        var title = "Error Creating Issue Report";
        var body = "There was an error creating your issue report. Please contact AppDevSupport@kenan-flagler.unc.edu.";
        if (data == 'complete') {
            title = "Issue Reported";
            var response = this.resources.filter(x => x.resourceId == this.IssueForm.resourceId)
            if (response.length == 1)
                body = response[0].resourceResponse + ' You will receive a confirmation email shortly.';
            else
                body = "Thank you for reporting an issue. You will receive a confirmation email shortly.";
        }
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.body = body;
        modalRef.componentInstance.okButton = "Close";
        modalRef.result.then((result) => {
            this.close();
        }, (reason) => {
                this.close();
        });

    }

    private loadResourcesIssues() {
        this.issueService.resourceIssues$.subscribe(
            (res) => {
                this.resources = res.resources;
                this.issues = res.issues;
                this.emergencyWeekendInfo = res.emergencyWeekendInfo;
            }
        );
    }

    validate() {
        this.issuesByType =  this.issueService.validateIssueData(this.IssueForm, this.resources, this.issues);
    }

    close() {
        this.router.navigate(['/facilities'])
    }

 }
